import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44d16ae3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "loading-wrap"
};
const _hoisted_2 = {
    key: 0,
    class: "loading-mask"
};
const _hoisted_3 = { class: "loading-box" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"loading-dots\" data-v-44d16ae3><div class=\"dot\" data-v-44d16ae3></div><div class=\"dot\" data-v-44d16ae3></div><div class=\"dot\" data-v-44d16ae3></div><div class=\"dot\" data-v-44d16ae3></div></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($data.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($data.modal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
                ($data.text !== '')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ 'white-text': $data.modal }, "text"])
                    }, _toDisplayString($data.text), 3))
                    : _createCommentVNode("", true),
                _hoisted_4
            ])
        ]))
        : _createCommentVNode("", true);
}
